import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'AVAILABILITIES' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/handlers.js